import React from 'react'
import SurveyCategoryComp from '../../Components/SurveyCategory/SurveyCategoryComp'

function SurveyCategory() {
    return <>
       <SurveyCategoryComp />
    </>
}

export default SurveyCategory